import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import classes from './styles.module.scss';

const Modal = ({ isOpen, onClose, children }: { isOpen: boolean; onClose: () => void; children: React.ReactNode }) => {
	// Обработка закрытия модального окна по Escape
	useEffect(() => {
		if (!isOpen) return;

		const handleEscape = (event: KeyboardEvent) => {
			if (event.key === 'Escape') {
				onClose();
			}
		};

		document.addEventListener('keydown', handleEscape);
		return () => document.removeEventListener('keydown', handleEscape);
	}, [isOpen, onClose]);

	if (!isOpen) return null;

	const modalRoot = document.getElementById('modal-root');

	// Обработка клика по overlay
	const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if (event.target === event.currentTarget) {
			onClose();
		}
	};


	return ReactDOM.createPortal(
		<div 
			className={classes['modal-overlay']} 
			onClick={handleOverlayClick}
			aria-hidden="true"
		>
			<dialog 
				className={classes['modal-content']} 
				open={isOpen}
				aria-modal="true"
			>
				<div>
					{children}
				</div>
				<button
					type="button"
					onClick={onClose}
					aria-label="Закрыть модальное окно"
					style={{
						position: 'absolute',
						top: '10px',
						right: '10px',
						background: 'transparent',
						border: 'none',
						fontSize: '20px',
						cursor: 'pointer',
						padding: '5px',
						lineHeight: '1'
					}}
				>
					×
				</button>
			</dialog>
		</div>,
		modalRoot!,
	);
};

export default Modal;
